// Thai Translation
export default {
  // Navigation
  navHome: 'หน้าแรก',
  navMethod: 'วิธีการ TSMC',
  navServices: 'บริการ',
  navAbout: 'เกี่ยวกับเรา',
  navFaq: 'คำถามที่พบบ่อย',
  navContact: 'ติดต่อและจองคิว',
  navBlog: 'BLOG',
  
  // Buttons
  bookNow: 'จองเลย',
  lineConsult: 'ปรึกษาทาง LINE',
  bookNowFull: 'จองเลย',
  
  // Hero
  heroTitle1: 'ความแม่นยำแบบวิศวกร',
  heroTitle2: 'ฟื้นฟูโครงสร้างร่างกาย',
  heroSubtitle: 'ไคโรแพรคติกและนวดกีฬาแบบมืออาชีพ ที่ไถหนาน เจียหลี่',
  heroDesc: 'ผสานเทคนิคชั้นนำจากสหรัฐฯ ญี่ปุ่น ออสเตรเลีย และแคนาดา | คลายพังผืดชั้นลึก | กลศาสตร์ของโครงสร้างร่างกาย',
  heroCert: 'ผ่านการรับรองจากหลายประเทศ',
  heroPrice: 'ราคาโปร่งใส',
  heroTime: 'เปิดทำการ เสาร์-พุธ',
  
  // What is Chiropractic
  whatIsTitle: 'อเมริกันไคโรแพรคติก',
  whatIsChiro: 'คืออะไร',
  whatIsSubtitle: "Chiropractic schools and manual traditions",
  whatIsPara1: "In some international systems, ",
  whatIsChiroFull: "Chiropractic",
  whatIsPara1b: " is a manual tradition that originated in the United States and was founded by ",
  whatIsFounder: 'Daniel David Palmer',
  whatIsPara1c: " in 1895. The following describes that school’s perspective.",
  whatIsPara2: "Within that tradition, specific manual methods are used to consider joint movement and whole-body use, ",
  whatIsRestore: "with adjustments guided by personal comfort",
  whatIsPara2b: "; this is not a disease diagnosis, medical treatment, or guarantee of a specific result.",
  whatIsBoxTitle: "Understanding daily body use as a whole",
  whatIsBoxDesc: "This approach considers daily loading, movement habits, and how different areas work together:",
  whatIsCycle1: "Repeated demands from work or exercise",
  whatIsCycle2: "Muscle tension and movement habits can influence each other",
  whatIsCycle3: "Different areas coordinate and compensate during movement",
  whatIsCycle4: "Look at everyday body use from a whole-body perspective",
  chiroCardTitle: 'อเมริกันไคโรแพรคติก',
  chiroCardDesc: 'เชี่ยวชาญด้าน',
  chiroCardFocus: 'การปรับโครงกระดูกและข้อต่อ',
  chiroCardDesc2: ' เพื่อฟื้นคืนการเคลื่อนไหวของข้อต่อให้เป็นปกติด้วยเทคนิคที่แม่นยำ',
  massageCardTitle: 'นวดกีฬา',
  massageCardDesc: 'เชี่ยวชาญด้าน',
  massageCardFocus: 'การคลายกล้ามเนื้อ',
  massageCardDesc2: ' ช่วยคลายความตึงของพังผืดชั้นลึกและปรับสมดุลกล้ามเนื้อ',
  whatIsSummary: 'TSMC ผสานทั้งสองแนวทางเข้าด้วยกัน',
  whatIsSummary2: ' เพื่อวิเคราะห์ว่าปัญหาเกิดจากระบบใด แล้วเลือกใช้เทคนิคที่เหมาะสม พร้อมมองทั้ง “สาเหตุ” และ “การป้องกัน” จากหลักกลศาสตร์และโครงสร้าง',
  
  // TSMC Method
  methodTitle: 'TSMC',
  methodTitleSuffix: 'Method',
  methodSubtitle: 'ระบบปรับโครงสร้างร่างกายเฉพาะของ TSMC',
  methodT: 'Technology',
  methodTSub: 'ผสานเทคนิคจากหลายประเทศ',
  methodTDesc: 'รวมเทคนิคไคโรแพรคติกชั้นนำจากสหรัฐฯ ญี่ปุ่น ออสเตรเลีย และแคนาดา เพื่อการดูแลที่ครอบคลุม',
  methodS: 'Stretching',
  methodSSub: 'การยืดเหยียดและปรับโครงสร้าง',
  methodSDesc: 'ปรับสมดุลโครงสร้างร่างกายอย่างเป็นระบบ ตั้งแต่กระดูกสันหลัง เชิงกราน ไปจนถึงข้อต่อของแขนขา',
  methodM: 'Mobility',
  methodMSub: 'เพิ่มประสิทธิภาพการเคลื่อนไหว',
  methodMDesc: 'ดูแลกล้ามเนื้อและพังผืดชั้นลึกเพื่อเพิ่มช่วงการเคลื่อนไหวและความยืดหยุ่นของข้อต่อ',
  methodC: 'Chiro',
  methodCSub: 'ไคโรแพรคติกแบบเฉพาะบุคคล',
  methodCDesc: 'ออกแบบแผนดูแลเฉพาะบุคคลตามสภาพร่างกาย อาการ และไลฟ์สไตล์ของแต่ละคน',
  methodSystemTitle: 'ร่างกายคือระบบชีวกลศาสตร์ที่แม่นยำ',
  methodSystem1: 'กระดูกเชื่อมกับกล้ามเนื้อ และกล้ามเนื้อดึงกระดูก',
  methodSystem2: 'กล้ามเนื้อออกแรงเพื่อพยุงกระดูก และกระดูกพยุงทั้งร่างกาย',
  methodSystem3: 'เพื่อต้านแรงโน้มถ่วงและรับมือกับแรงต่าง ๆ ในชีวิตประจำวัน',
  
  // Services
  services: 'บริการระดับมืออาชีพ',
  servicesDesc: 'การดูแลแบบสองแนวทาง - อเมริกันไคโรแพรคติก + นวดกีฬา',
  chiro: 'อเมริกันไคโรแพรคติก',
  chiroService: "Specific manual methods · Daily movement care · Body awareness",
  chiroFeature1: "Manual methods adjusted to personal comfort",
  chiroFeature2: "Consider everyday movement and body-use habits",
  chiroFeature3: "Daily care for seated, standing, and physical-work lifestyles",
  chiroPrice: '$1000',
  chiroPriceSuffix: 'ขึ้นไป / 30-40 นาที',
  massage: 'ไคโรแพรคติก + นวดกีฬา',
  massageService: "Manual care · Deep fascial relaxation · Post-exercise care",
  massageFeature1: "Deep muscle and fascial relaxation based on personal needs",
  massageFeature2: "Post-exercise relaxation for regularly active people",
  massageFeature3: "Whole-body relaxation for office and physical workers",
  massagePrice: '$2300',
  massagePriceSuffix: '/ 90 นาที',
  suitable: 'เหมาะสำหรับ:',
  chiroSuitable: "office workers, standing workers, physical workers, and people who value daily body care",
  massageSuitable: "active people, office workers, physical workers, and those seeking post-exercise relaxation",
  
  // Services Summary
  servicesSummary1: "Two-track bodywork: manual care + massage",
  servicesSummary2: ", tailored to lifestyle and everyday relaxation needs",
  
  // Who Needs Our Services
  whoNeedsTitle: "ไลฟ์สไตล์แบบใดเหมาะกับการดูแลร่างกายในชีวิตประจำวัน?",
  whoNeedsSubtitle: "แบ่งตามไลฟ์สไตล์และการใช้งานร่างกาย ไม่ใช่การวินิจฉัยหรือรักษาโรค",
  
  // Target Groups
  targetOffice: "กลุ่มทำงานโต๊ะและสำนักงาน",
  targetOfficeSymptom1: "ใช้คอมพิวเตอร์เป็นเวลานาน",
  targetOfficeSymptom2: "มีกิจกรรมในชีวิตประจำวันน้อย",
  targetOfficeSymptom3: "อยู่ในท่าเดิมเป็นเวลานาน",
  targetOfficeSymptom4: "ต้องการผ่อนคลายคอ ไหล่ และหลังในชีวิตประจำวัน",
  
  targetAthlete: "กลุ่มออกกำลังกายสม่ำเสมอ",
  targetAthleteSymptom1: "ฝึกเวทหรือเล่นกีฬาประเภทบอล",
  targetAthleteSymptom2: "ต้องการผ่อนคลายหลังออกกำลังกาย",
  targetAthleteSymptom3: "ให้ความสำคัญกับการยืดและดูแลประจำวัน",
  targetAthleteSymptom4: "ต้องการเข้าใจรูปแบบการใช้ร่างกาย",
  
  targetPosture: "กลุ่มทำงานยืน",
  targetPostureSymptom1: "งานต้องยืนเป็นเวลานาน",
  targetPostureSymptom2: "เดินบ่อยหรืออยู่ในท่าเดิม",
  targetPostureSymptom3: "ใช้ขามากในชีวิตประจำวัน",
  targetPostureSymptom4: "ต้องการผ่อนคลายขาและทั่วร่างกาย",
  
  targetChronic: "กลุ่มใช้แรงกาย",
  targetChronicSymptom1: "ยกหรือขนของบ่อย",
  targetChronicSymptom2: "ทำท่าซ้ำเป็นเวลานาน",
  targetChronicSymptom3: "มีภาระทางกายในแต่ละวันสูง",
  targetChronicSymptom4: "ต้องการผ่อนคลายกล้ามเนื้อทั่วร่างกาย",
  
  targetSenior: "กลุ่มเดินทางและขับขี่",
  targetSeniorSymptom1: "ขับรถหรือขี่รถเป็นเวลานานทุกวัน",
  targetSeniorSymptom2: "เดินทางไกลหรือเดินทางไปทำงานเป็นประจำ",
  targetSeniorSymptom3: "งานต้องอยู่ในท่าขับขี่คงที่",
  targetSeniorSymptom4: "ต้องการผ่อนคลายทั่วร่างกายในเวลาพัก",
  
  targetPregnant: "กลุ่มดูแลร่างกายเป็นประจำ",
  targetPregnantSymptom1: "ไม่มีความต้องการรักษาโรคเฉพาะ",
  targetPregnantSymptom2: "ให้ความสำคัญกับการผ่อนคลายและดูแลตนเอง",
  targetPregnantSymptom3: "ต้องการเข้าใจรูปแบบการเคลื่อนไหวประจำวัน",
  targetPregnantSymptom4: "จัดเวลาสำหรับ body care เป็นประจำ",
  
  // About Us
  aboutTitle: 'จากวิศวกรสู่ผู้ดูแลร่างกาย',
  aboutSubtitle: 'แนวคิดและวิธีการทำงาน',
  aboutPara1: 'วิธีคิดแบบวิศวกรคือการมุ่ง',
  aboutPara1Highlight: '“แก้ปัญหาจากต้นตอ”',
  aboutPara1b: ' เหมือนกับการดีบักโค้ด เราไม่ได้ดูแค่อาการปวด แต่หาสาเหตุเชิงโครงสร้างที่แท้จริง',
  aboutPara2: 'การปรับแต่ละครั้งเปรียบเหมือนการคอมไพล์โครงสร้างร่างกายใหม่ เราผสานเทคนิคชั้นนำจาก',
  aboutPara2Highlight: 'สหรัฐฯ ญี่ปุ่น ออสเตรเลีย และแคนาดา',
  aboutPara2b: ' พร้อมใช้ความแม่นยำแบบวิศวกรเพื่อดูแลร่างกายของคุณอย่างลึกที่สุด',
  aboutPara3: 'ที่ไถหนาน เจียหลี่ เรามอบมากกว่าการนวดแบบดั้งเดิม แต่เป็น',
  aboutPara3Highlight: 'การดูแลร่างกายอย่างเป็นระบบ',
  aboutPara3b: ' ที่ผสานกายวิภาคศาสตร์สมัยใหม่ ชีวกลศาสตร์ และวิทยาศาสตร์การกีฬา',
  aboutQuote: 'ร่างกายคือระบบชีวกลศาสตร์ที่ละเอียดอ่อน สิ่งที่ต้องการไม่ใช่การซ่อมชั่วคราว แต่คือการฟื้นฟูโครงสร้างอย่างเป็นระบบ เราใช้ตรรกะแบบวิศวกรรมร่วมกับเทคนิคระดับมืออาชีพ เพื่อช่วยให้ลูกค้าแต่ละคนกลับสู่สภาพร่างกายที่ดีที่สุด',
  aboutQuoteAuthor: '— ผู้ก่อตั้ง TSMC',
  
  // FAQ
  faqTitle: 'คำถามที่พบบ่อย',
  faqSubtitle: 'เกี่ยวกับไคโรแพรคติกและการนวดที่ไถหนาน เจียหลี่',
  
  // FAQ Q&A
  faq1Q: 'อเมริกันไคโรแพรคติกต่างจากการนวดแบบดั้งเดิมอย่างไร?',
  faq1A: 'อเมริกันไคโรแพรคติกเน้น “การปรับแนวโครงกระดูกและข้อต่อ” เพื่อฟื้นคืนการเคลื่อนไหวของข้อต่อและปรับกลไกร่างกายอย่างตรงจุด ส่วนการนวดแบบดั้งเดิมเน้นการผ่อนคลายกล้ามเนื้อและการไหลเวียน TSMC ผสานทั้งสองแบบเพื่อให้การดูแลครบถ้วนยิ่งขึ้น',
  
  faq2Q: 'จะเจ็บไหม? ปลอดภัยหรือไม่?',
  faq2A: 'เทคนิคของเราผ่านการฝึกอบรมอย่างมืออาชีพ คุณอาจรู้สึกตึงหรือมีแรงกดเล็กน้อย แต่ไม่ควรเจ็บ ทุกขั้นตอนอยู่ภายในขอบเขตที่ปลอดภัยและปรับตามสภาพร่างกายของคุณ',
  
  faq3Q: 'ควรมาบ่อยแค่ไหน?',
  faq3A: 'ขึ้นอยู่กับอาการของแต่ละคน หากเป็นอาการเฉียบพลัน แนะนำ 1-2 ครั้งต่อสัปดาห์ สำหรับอาการเรื้อรัง อาจต้องมาถี่ขึ้นในช่วงแรก (สัปดาห์ละ 1 ครั้ง) แล้วค่อยขยายเป็นทุก 2-4 สัปดาห์เพื่อการดูแลระยะยาว เราจะประเมินและแนะนำตามสภาพจริงของคุณ',
  
  faq4Q: 'ครั้งแรกควรเตรียมอะไรมา?',
  faq4A: 'สวมเสื้อผ้าที่หลวมและสบาย หากเคยมีผลตรวจร่างกาย เช่น X-ray หรือ MRI สามารถนำมาประกอบการประเมินได้ เราจะตรวจร่างกายอย่างละเอียดก่อนวางแผนดูแลเฉพาะบุคคล',
  
  faq5Q: 'คิดค่าบริการอย่างไร?',
  faq5A: 'อเมริกันไคโรแพรคติกเริ่มต้นที่ $1000 (30-40 นาที) ส่วนไคโรแพรคติก + นวดกีฬา ราคา $2300 (90 นาที) ราคาโปร่งใส ไม่มีค่าใช้จ่ายแอบแฝง สำหรับผู้ที่มาครั้งแรก เราแนะนำให้เริ่มจากอเมริกันไคโรแพรคติกเพื่อประเมินอาการและแนะนำบริการที่เหมาะสม',
  
  faq6Q: 'ถ้าอยู่นอกเขตไถหนาน เจียหลี่ มารับบริการได้ไหม?',
  faq6A: 'ได้แน่นอน! เราให้บริการลูกค้าจากหลายพื้นที่ในไถหนาน เช่น เจียหลี่ หมาตู้ เสวียเจี่ย เจียงจวิน ชี๋กู่ ซี๋กั่ง อันติ้ง และพื้นที่ใกล้เคียง การเดินทางสะดวก ใช้ Google Maps นำทางได้',
  
  // Reviews
  reviewsTitle: 'เสียงตอบรับจากลูกค้าจริง',
  reviewsSubtitle: 'จากลูกค้าที่มอบรีวิว 5 ดาวให้เรา',
  reviewsDisclaimer: 'TSMC ไม่ใช่สถานพยาบาล ข้อความด้านล่างคัดมาจากรีวิวของลูกค้าบน Google และสะท้อนเพียงประสบการณ์ส่วนบุคคลของผู้รีวิว ไม่ใช่การกล่าวอ้างหรือรับประกันผลทางการแพทย์หรือผลลัพธ์ของบริการจาก TSMC',
  reviewsViewAll: 'ดูรีวิวทั้งหมดบน Google',
  reviewsFrom: 'แหล่งที่มา',
  
  // Training
  trainingTitle: 'การพัฒนาวิชาชีพระดับนานาชาติ',
  trainingSubtitle: 'พัฒนาทักษะอย่างต่อเนื่อง',
  trainingIntro: 'ตลอดหลายปีที่ผ่านมา เราเรียนรู้จากผู้สอนมืออาชีพทั่วโลกอย่างต่อเนื่อง พัฒนาทักษะไม่หยุด และนำแนวคิดไคโรแพรคติกสมัยใหม่กลับมาประยุกต์ใช้ในไต้หวัน',
  trainingYear: '',
  trainingStats1: 'เรียนรู้อย่างต่อเนื่อง',
  trainingStats1Val: '10+ ปี',
  trainingStats2: 'ผู้สอนนานาชาติ',
  trainingStats2Val: '10+ ท่าน',
  trainingStats3: 'การอบรมข้ามประเทศ',
  trainingStats3Val: 'หลายครั้ง',
  
  // CTA
  ctaTitle: "พร้อมจัดเวลาดูแลร่างกายในชีวิตประจำวันหรือยัง?",
  ctaDesc: "เลือกบริการ bodywork ที่ไม่ใช่การแพทย์ตามไลฟ์สไตล์และความต้องการผ่อนคลาย",
  ctaBooking: 'จองออนไลน์',
  ctaLine: 'ปรึกษาออนไลน์ทาง LINE',
  ctaTransparent: 'ราคาโปร่งใส',
  ctaTransparentDesc: 'ไม่มีค่าใช้จ่ายแอบแฝง\nราคาชัดเจน',
  ctaCert: 'ได้รับการรับรองอย่างมืออาชีพ',
  ctaCertDesc: 'เทคนิคจาก\nหลายประเทศ',
  ctaFlex: 'จองคิวง่ายและยืดหยุ่น',
  ctaFlexDesc: 'ระบบออนไลน์\nรวดเร็วและสะดวก',
  
  // Footer
  footerHours: 'เวลาทำการ',
  footerHoursDays: 'วันเสาร์ถึงวันพุธ',
  footerHoursTime: '11:00 - 21:40 น.',
  footerHoursClosed: 'ปิดทุกวันพฤหัสบดีและศุกร์',
  footerLocation: 'สถานที่',
  footerLocationCity: 'เขตเจียหลี่ เมืองไถหนาน',
  footerLocationAddr: 'เลขที่ 130-95 อันซี หมู่บ้านเหวินซิน',
  footerLocationMap: 'นำทางด้วย Google Maps',
  footerLocationSearch: 'เปิดตำแหน่ง TSMC Chiro Studio ใน Google Maps โดยตรง',
  footerLocationGuide: 'ไม่ต้องค้นหาที่อยู่เอง กดปุ่มด้านล่างเพื่อนำทางไปยังตำแหน่งโดยตรง',
  footerLocationOpenMap: 'เปิดนำทาง Google Maps โดยตรง',
  footerContact: 'ติดต่อ',
  footerContactLine: 'บัญชีทางการ LINE',
  footerFollow: 'ติดตามเรา',
  footerServices: 'บริการ',
  footerService1: 'อเมริกันไคโรแพรคติก',
  footerService2: 'เพิ่มการเคลื่อนไหวของข้อต่อ',
  footerService3: 'นวดกีฬา',
  footerService4: 'คลายพังผืดชั้นลึก',
  footerService5: 'ปรับเชิงกราน',
  footerService6: 'ประเมินและปรับท่าทาง',
  footerDisclaimer: 'ประกาศสำคัญ:',
  footerDisclaimerText: "TSMC ให้บริการ bodywork แบบดั้งเดิมและนวดกีฬาในรูปแบบที่ไม่ใช่การแพทย์ เพื่อการผ่อนคลาย ดูแลร่างกาย และเพิ่มการรับรู้ร่างกาย เราไม่วินิจฉัยหรือรักษาโรคและไม่ให้บริการฟื้นฟู หากมีอาการปวดต่อเนื่อง ชา อ่อนแรง เวียนศีรษะ บาดเจ็บเฉียบพลัน หรือสงสัยภาวะทางการแพทย์ โปรดพบแพทย์ที่มีใบอนุญาตก่อน",
  footerBookingBtn: '🎯 จองออนไลน์ตอนนี้',
  footerCopyright: '© 2026 TSMC - สตูดิโอไคโรแพรคติกและนวดกีฬาแบบมืออาชีพ ที่ไถหนาน เจียหลี่',
  footerTagline1: 'Technology of Stretching & Mobility Chiro',
  footerTagline2: 'Tainan Jiali · ไคโรแพรคติกและนวดกีฬาแบบมืออาชีพ',

  
  // Service Flow
  serviceFlowTitle: 'ขั้นตอนการให้บริการของเรา',
  serviceFlowSubtitle: 'ตั้งแต่การประเมินอย่างมืออาชีพจนถึงการปรับแก้อย่างแม่นยำ ทุกขั้นตอนออกแบบมาเพื่อการดูแลที่ดีที่สุด',
  serviceFlowPhase1: 'ขั้นตอนการประเมิน',
  serviceFlowPhase2: 'ขั้นตอนการปรับแก้',
  serviceFlowScrollHint: 'เลื่อนเพื่อดูขั้นตอนทั้งหมด',
  step1Title: 'สังเกตการเคลื่อนไหวเฉพาะบุคคล',
  step1Desc: 'สังเกตท่าทางบางอย่างตามความสบายของแต่ละคน เพื่อทำความเข้าใจกิจกรรมประจำวันและรูปแบบการใช้ร่างกาย',
  step2Title: 'ประเมินความยาวขา',
  step2Desc: 'วัดความต่างของเชิงกรานและความยาวขาอย่างแม่นยำ เพื่อหาความไม่สมดุลของโครงสร้าง',
  step3Title: 'ตรวจเท้า',
  step3Desc: 'ตรวจการกระจายแรงกดฝ่าเท้าและลักษณะอุ้งเท้า เพื่อประเมินปัญหาการเดิน',
  step4Title: 'ทดสอบแรงกด',
  step4Desc: 'ประเมินแรงตึงของกล้ามเนื้อและการเคลื่อนไหวของข้อต่อ เพื่อยืนยันจุดที่มีปัญหา',
  step5Title: 'ปรับหลัง',
  step5Desc: 'คลายพังผืดและกล้ามเนื้อหลังชั้นลึก เพื่อปรับสมดุลแรงตึงของหลัง',
  step6Title: 'ปรับคอและไหล่',
  step6Desc: 'ปรับอย่างแม่นยำสำหรับอาการคอและไหล่ตึง เพื่อฟื้นคืนการเคลื่อนไหว',
  step7Title: 'ตรวจเช็กครบถ้วน',
  step7Desc: 'ประเมินซ้ำหลังจบเซสชัน เพื่อยืนยันผลลัพธ์และให้คำแนะนำต่อเนื่อง'
};
